import { cn } from "@/lib/utils";
import { Button } from "../ui/Button";

const ToggleButton = ({
    isActive,
    loading,
    disabled,
    onToggle,
    onText = 'ON',
    offText = 'OFF',
}) => {
    return (
        <Button
            onClick={onToggle}
            disabled={loading || disabled}
            className={cn(
                "relative flex items-center w-[50px] h-6 px-2 rounded-full transition-all duration-300",
                isActive ? "bg-green-400" : "bg-gray-500",
                (loading || disabled) && "opacity-60 cursor-not-allowed"
            )}
        >
            {/* Label */}
            {/* <span
                className={cn(
                    "text-[13px] font-bold leading-none transition-all duration-300",
                    isActive
                        ? "text-green-900 ml-2"
                        : "text-white ml-7"
                )}
            >
                {loading ? "..." : isActive ? onText : offText}
            </span> */}

            {/* Knob */}
            <div
                className={cn(
                    "absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-all duration-300",
                    isActive ? "right-1" : "left-1"
                )}
            />
        </Button>
    );
}

export default ToggleButton;